import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/utils.js';
export const Input = React.forwardRef(({ className, ...props }, ref) => (_jsx("input", { ref: ref, className: cn(
    // No invalid border state by design — errors are a <FormError/> line
    // next to the field. Height follows the shell contract; focus is the
    // platform-wide --focus-ring from theme.css.
    'h-(--control-height) w-full rounded-md border border-input bg-card px-3 text-sm text-foreground shadow-xs outline-none transition-colors placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50', className), ...props })));
Input.displayName = 'Input';
// Small labelled-field helper: <Field label="Email"><Input .../></Field>
export function Field({ label, children, className }) {
    return (_jsxs("label", { className: cn('block', className), children: [_jsx("span", { className: "text-xs text-muted-foreground", children: label }), _jsx("div", { className: "mt-1", children: children })] }));
}
